<ng-container *ngIf="graphData">
    <div
        [id]="graphId"
        class="pieChart"
        [style.height.px]="graphData.height ? graphData.height : 250"
        [class.getFullAccessState]="graphData.liteState"
    ></div>
</ng-container>
